import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  CompletenessLevel,
  levelLabelKey,
} from '../../../shared/model/profile-completeness';

/** Feste Reihenfolge der drei Schalter (NP20-1190). */
const FILTER_LEVELS: CompletenessLevel[] = ['complete', 'few', 'many'];

export type CompletenessCounts = Record<CompletenessLevel, number>;

export function emptyCompletenessCounts(): CompletenessCounts {
  return { complete: 0, few: 0, many: 0 };
}

/**
 * NP20-1192: Die Filterleiste der Ampel — drei Schalter in fester Reihenfolge, je mit
 * Punkt, Bezeichnung und der Zahl der Berater in dieser Stufe.
 *
 * Die Zahlen rechnet die Uebersicht ueber alle uebrigen Filter, aber ohne den Ampelfilter
 * selbst; sonst wuerden sie sich beim Klicken selbst veraendern. Die Schalter sind
 * Schaltflaechen mit `aria-pressed`, kein Formularfeld — es gibt nichts zu validieren.
 *
 * `@spirit-testing/component-library` bringt keinen Chip mit (nur `lib-badge` ohne
 * Zustand und ohne Klick); die Schalter folgen deshalb den `sorter__fchip`-Elementen der
 * Werkzeugleiste darueber, benannt im Block der Uebersicht.
 */
@Component({
  selector: 'app-completeness-filter',
  templateUrl: './completeness-filter.component.html',
  styleUrl: './completeness-filter.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class CompletenessFilterComponent {
  @Input() selected: CompletenessLevel[] = [];
  @Input() counts: CompletenessCounts = emptyCompletenessCounts();

  @Output() selectedChange = new EventEmitter<CompletenessLevel[]>();

  protected readonly levels = FILTER_LEVELS;
  protected readonly levelLabelKey = levelLabelKey;

  protected isActive(level: CompletenessLevel): boolean {
    return this.selected.includes(level);
  }

  protected toggle(level: CompletenessLevel): void {
    this.selectedChange.emit(
      this.isActive(level)
        ? this.selected.filter((entry) => entry !== level)
        : [...this.selected, level],
    );
  }

  protected reset(): void {
    this.selectedChange.emit([]);
  }
}
